import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/uk/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/uk/images/heroBg.png";

import uk from "../../images/v4/country/uk/icons/uk.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.webp";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/uk/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/uk/images/countryBackground.png";
import benefitImg from "../../images/v4/country/uk/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/uk/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/uk/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/uk/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/uk/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(270deg, #208EEC 9.15%, #FF1D5A 65.63%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#F1FAF9",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #009A99 0%, #005353 98.63%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const HongKong = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "What is a CRM system, and why does my UK business need one?",
      answer: (
        <>
          A CRM (Customer Relationship Management) system helps you manage
          customer interactions, sales pipelines, and marketing activities in
          one place, improving efficiency and customer engagement.
        </>
      ),
    },
    {
      question: "How to get CRM for your growing business in the UK?",
      answer: (
        <>
          <ul>
            <li>
              Getting started with the best CRM for UK businesses is easier than
              ever. Whether you’re just starting out or scaling up, Pepper Cloud
              CRM offers a simple, effective solution to manage leads, sales,
              and customer interactions seamlessly.
            </li>
            <li>
              Start with a free demo to explore the powerful features of Pepper
              Cloud CRM through a tailored walkthrough.
            </li>
            <li>
              Consult with our UK-based CRM experts to find the perfect plan and
              features to meet your business goals.
            </li>
            <li>
              Set up your account effortlessly, with no setup fees and a
              user-friendly interface designed for quick adoption.
            </li>
            <li>
              Customise your CRM to fit your specific workflows, sales
              pipelines, and automation needs for enhanced efficiency.
            </li>
            <li>
              Go live and leverage AI-powered tools to streamline customer
              management, boost productivity, and optimise your sales
              performance.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How to choose the best CRM for your business in UK",
      answer: (
        <>
          <ul>
            <li>
              Assess Your Needs: Look for features like AI-powered lead capture,
              sales pipeline management, and multichannel communication.
            </li>
            <li>
              Localisation: Choose a CRM like Pepper Cloud that is tailored for
              the UK market, with WhatsApp integration and UK-based support.
            </li>
            <li>
              Essential Features: Ensure your CRM offers automated workflows,
              customisable reporting, and easy integration with existing tools.
            </li>
            <li>
              Scalability: Select a CRM that grows with your business, like
              Pepper Cloud, which offers flexible, scalable plans.
            </li>
            <li>
              User-Friendly: Opt for a CRM with an intuitive interface to ensure
              fast team adoption.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How can CRM software help improve sales for my UK business?",
      answer: (
        <>
          CRM software like Pepper Cloud streamlines lead management, automates
          follow-ups, and provides real-time insights to help your sales team
          close more deals and increase conversions.
        </>
      ),
    },
    {
      question: "Can I access my CRM data remotely?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers a mobile app, allowing your team to
          access customer data, update records, and communicate with customers
          while on the go, whether in the field or working remotely.
        </>
      ),
    },
    {
      question: "How do I choose the best CRM for my business?",
      answer: (
        <>
          Consider your business size, industry needs, and key features like
          sales pipeline management, AI-powered insights, and customisable
          workflows. Pepper Cloud CRM is a great option for UK businesses
          seeking scalability, flexibility, and ease of use.
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM suitable for small and medium-sized UK businesses?",
      answer: (
        <>
          Yes. Pepper Cloud CRM is designed to scale with your business,
          offering flexible features and pricing ideal for startups, SMEs, and
          growing enterprises across the UK.
        </>
      ),
    },
    {
      question: "Can I try Pepper Cloud CRM before purchasing?",
      answer: (
        <>
          Yes. You can book a free demo or access a trial version to explore
          features and see how it fits your UK business needs.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Pipedrive CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is a comprehensive solution designed for UK businesses, offering powerful lead management, AI-driven insights, and multichannel communication. Its user-friendly interface and scalable features make it suitable for businesses of all sizes in the United Kingdom.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-powered suite",
          desc: "Optimise operations with chatbots, real-time sales assistance, and automated task management, using the best CRM software the United Kingdom has to offer.",
        },
        {
          title: "WhatsApp CRM integration",
          desc: "Directly engage with customers through WhatsApp, the most popular messaging platform in the UK.",
        },
        {
          title: "Lead management",
          desc: "Track and capture leads efficiently with web forms, UTM tracking, and AI-driven workflows tailored to UK business needs.",
        },
        {
          title: "Omnichannel connectivity",
          desc: "Manage customer interactions across email, voice/video calls, social media, and messaging apps using an advanced CRM provider that United Kingdom businesses rely on.",
        },
        {
          title: "Automated workflows",
          desc: "Streamline sales processes with auto lead routing, follow-ups, and task reminders for improved productivity in your UK business.",
        },
        {
          title: "Customisable dashboards",
          desc: "Create tailored reports and visualisations to make data-driven decisions for your UK business.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM offers a robust solution with powerful marketing automation tools, a user-friendly interface, and a free version suitable for small businesses in the UK. It is a great choice for businesses aiming to improve their sales and marketing alignment.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Pipeline builder",
          desc: "Customise your sales pipeline with a simple drag-and-drop tool to streamline your UK business processes.",
        },
        {
          title: "Marketing automation",
          desc: "Automatically nurture leads and create targeted campaigns for UK audiences.",
        },
        {
          title: "Free tier",
          desc: "Basic CRM features are available at no cost, ideal for UK businesses starting.",
        },
        {
          title: "Integration ecosystem",
          desc: "A wide range of integrations with UK-based apps to enhance your CRM's functionality.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce offers extensive customisation and powerful reporting capabilities for UK businesses. It is ideal for companies that require an advanced CRM solution to meet their specific needs.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "AppExchange marketplace",
          desc: "Access industry-specific apps and integrations for various UK sectors.",
        },
        {
          title: "Einstein AI",
          desc: "AI-powered predictive insights to help UK businesses forecast trends and customer behaviour.",
        },
        {
          title: "Customisable workflows",
          desc: "Tailor the CRM processes to suit UK business requirements.",
        },
        {
          title: "Advanced reporting",
          desc: "Track sales performance and customer satisfaction through detailed analytics with the best CRM software for UK businesses.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM provides an affordable solution for small and medium-sized UK businesses. With mobile accessibility and AI features, it helps streamline customer management and sales operations.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Use the AI-powered assistant to get predictive sales insights and automate tasks for your UK business.",
        },
        {
          title: "Multichannel communication",
          desc: "Manage customer interactions across multiple platforms, including email and social media, using CRM software that fits your UK business.",
        },
        {
          title: "Customisable modules",
          desc: "Tailor the CRM to your UK-specific business processes.",
        },
        {
          title: "Gamification features",
          desc: "Enhance sales team motivation with gamified tools to boost performance for UK sales teams.",
        },
      ],
    },
    {
      title: "Pipedrive CRM",
      desc: "With powerful automation features, intuitive pipeline management, and integration with popular tools, Pipedrive helps UK businesses close deals faster and manage customer relationships more effectively.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Sales pipeline management",
          desc: "Easily track and manage leads across stages, ensuring no opportunity is missed for your UK business.",
        },
        {
          title: "AI-driven sales assistance",
          desc: "Gain real-time insights and predictive analytics to optimise your sales strategy in the UK market.",
        },
        {
          title: "Automated workflows",
          desc: "Streamline tasks like lead routing and follow-ups, boosting productivity for UK sales teams.",
        },
        {
          title: "Multichannel communication",
          desc: "Engage customers across email, WhatsApp, and more from a single inbox using the best CRM provider United Kingdom businesses trust.",
        },
        {
          title: "Customisable reporting",
          desc: "Tailor dashboards and reports to track performance and forecast growth for UK businesses.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate routine tasks, deliver real-time sales assistance, and provide 24/7 support via chatbots and insights.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Capture and manage leads from WhatsApp, website forms, and social media—all in one place with a top CRM provider United Kingdom companies trust.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Visualise your entire pipeline, use forecasting tools, and customise multi-level stages to close deals faster.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Reduce manual work and increase efficiency with lead routing, follow-ups, reminders, and more—trusted by leading CRM companies in the UK.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Engage customers across the UK through WhatsApp automation, predefined conversation flows, and easy group management.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "Manage messages from email, WhatsApp, Facebook, Instagram, and other platforms in one powerful CRM platform.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Keep your sales team organised with task assignments, meeting scheduling, and follow-up tracking.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM app",
      desc: "Access your CRM on the go—perfect for UK sales teams who need flexibility and remote access.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Integrate Pepper Cloud CRM with your essential tools like Google Workspace, marketing software, and more for a seamless experience.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "AI lead capture",
          content:
            "Capture leads from WhatsApp, email, and social media via AI workflows.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI upselling & support",
          content: "Suggest products and offer 24/7 chat support with AI.",
          alt: "E-commerce CRM",
        },
        {
          heading: "Omnichannel CRM",
          content: "Manage WhatsApp, email, and social media in one inbox.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI insights",
          content:
            "Track conversions and analyse customer preferences for better sales.",
          alt: "E-commerce CRM",
        },
      ],
      img: realWorldImg1,
      alt: "E-commerce CRM for Hong Kong",
      subtitle:
        "Boost online sales with AI-powered CRM, optimising customer interactions and increasing conversions for UK e-commerce businesses, using the best CRM software the United Kingdom has to offer.",
    },
    {
      tabContent: [
        {
          heading: "AI-driven scheduling",
          content: "Automate bookings, reminders, and reschedules with AI.",
          alt: "Healthcare CRM",
        },
        {
          heading: "AI-powered patient support",
          content: "Offer instant chatbot responses to patient queries.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Centralised patient communication",
          content: "Manage all patient communication channels in one platform.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Secure data insights",
          content:
            "Share reports, track interactions, and ensure compliance with secure data insights.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Healthcare CRM for Hong Kong",
      subtitle:
        "Improve patient care and reduce administrative burden with AI-powered CRM, ideal for UK healthcare providers.",
    },
    {
      tabContent: [
        {
          heading: "AI-powered AssistAI",
          content:
            "Provide instant responses to student queries, boosting engagement.",
          alt: "Education CRM",
        },
        {
          heading: "Class Automation & Reminders",
          content:
            "Automate classes, reminders, and assignments with CRM software UK.",
          alt: "Education CRM",
        },
        {
          heading: "Omnichannel Communication",
          content:
            "Communicate via WhatsApp, email, and portals in one CRM platform.",
          alt: "Education CRM",
        },
        {
          heading: "AI insights",
          content: "Use AI to monitor student engagement and improve outcomes.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Education CRM for Hong Kong",
      subtitle:
        "Enhance student engagement and streamline academic administration with AI-powered CRM for UK educational institutions.",
    },
    {
      tabContent: [
        {
          heading: "AI-Powered Lead Nurturing",
          content:
            "Automate lead nurturing with AI, sending personalised property recommendations.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Smart Scheduling",
          content:
            "Automate property viewings with AI-driven scheduling for clients.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Omnichannel CRM",
          content:
            "Streamline communication with buyers via WhatsApp, email, and phone.",
          alt: "Real Estate CRM",
        },
        {
          heading: "AI Insights",
          content:
            "Track sales, optimise follow-ups, and boost conversions with AI insights.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Real Estate CRM for Hong Kong",
      subtitle:
        "Accelerate property sales and lead nurturing with AI-driven CRM, tailored for the UK real estate market.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software in the United Kingdom?",
      content:
        "CRM software United Kingdom helps businesses streamline sales, marketing, and service while complying with local regulations. A leading CRM provider in the United Kingdom, Pepper Cloud offers AI-driven tools, automation, and omnichannel support—making it a top choice for those seeking the best CRM software in the United Kingdom.",
    },
    {
      heading: "Why do UK businesses need a CRM?",
      content:
        "The best CRM software in the United Kingdom helps businesses streamline operations, build stronger customer relationships, and drive growth. With automation, AI insights, and GDPR compliance, top CRM companies in the United Kingdom like Pepper Cloud support everything from sales to service securely and efficiently.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud combines sales, marketing automation, and customer service in a single platform—perfect for businesses using CRM software in the United Kingdom to streamline daily operations.",
      img: bestIcon1,
    },
    {
      pointer: "Tailored for all business sizes",
      desc: "Whether you're a startup, SME, or enterprise, this CRM provider in the United Kingdom offers scalable features that grow with your business.",
      img: bestIcon2,
    },
    {
      pointer: "Affordable pricing",
      desc: "Known for transparency and no setup fees, Pepper Cloud is a smart choice for UK SMEs seeking the best CRM software in the United Kingdom.",
      img: bestIcon3,
    },
    {
      pointer: "24/7 UK support",
      desc: "Our support team, familiar with the local market, ensures you get timely help, making us one of the most reliable CRM companies in the United Kingdom.",
      img: bestIcon4,
    },
    {
      pointer: "Customisable workflows",
      desc: "Easily adapt your CRM with automation, pipeline stages, and fields that fit your sales process, designed to meet the evolving needs of UK businesses.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Built for UK businesses, ensuring full GDPR compliance and reliable local support when you need it.",
    "Streamline your sales process with AI-powered automation that boosts efficiency and closes deals faster.",
    "Access your CRM anywhere with a mobile-friendly interface—perfect for remote and field sales teams across the UK.",
    "Centralise all communication by integrating WhatsApp, email, and social channels into one easy-to-manage platform.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM software United Kingdom"}
        pathname={
          "https://peppercloud.com/country/best-crm-software-for-united-kingdom/"
        }
        keywords="CRM companies in the United Kingdom, CRM provider United Kingdom, What is CRM software in the United Kingdom?"
        description={
          "Discover Pepper Cloud, the best CRM software for United Kingdom(UK) businesses. Boost sales, marketing, and customer service with AI-driven solutions and automation tools."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is a CRM system, and why does my UK business need one?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A CRM (Customer Relationship Management) system helps you manage customer interactions, sales pipelines, and marketing activities in one place, improving efficiency and customer engagement.",
                },
              },
              {
                "@type": "Question",
                name: "How to get CRM for your growing business in the UK?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Getting started with the best CRM for UK businesses is easier than ever. Whether you’re just starting out or scaling up, Pepper Cloud CRM offers a simple, effective solution to manage leads, sales, and customer interactions seamlessly.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM for your business in UK",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Assess Your Needs: Look for features like AI-powered lead capture, sales pipeline management, and multichannel communication. Localisation: Choose a CRM like Pepper Cloud that is tailored for the UK market, with WhatsApp integration and UK-based support.",
                },
              },
              {
                "@type": "Question",
                name: "How can CRM software help improve sales for my UK business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM software like Pepper Cloud streamlines lead management, automates follow-ups, and provides real-time insights to help your sales team close more deals and increase conversions.",
                },
              },
              {
                "@type": "Question",
                name: "Can I access my CRM data remotely?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM offers a mobile app, allowing your team to access customer data, update records, and communicate with customers while on the go, whether in the field or working remotely.",
                },
              },
              {
                "@type": "Question",
                name: "How do I choose the best CRM for my business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Consider your business size, industry needs, and key features like sales pipeline management, AI-powered insights, and customisable workflows. Pepper Cloud CRM is a great option for UK businesses seeking scalability, flexibility, and ease of use.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for small and medium-sized UK businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud CRM is designed to scale with your business, offering flexible features and pricing ideal for startups, SMEs, and growing enterprises across the UK.",
                },
              },
              {
                "@type": "Question",
                name: "Can I try Pepper Cloud CRM before purchasing?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. You can book a free demo or access a trial version to explore features and see how it fits your UK business needs.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Boost sales with the Best CRM in the{" "}
              <img className="countryLogo" src={uk} alt="united kingdom" />{" "}
              <span className="countryHighlight">United Kingdom</span>!
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Supercharge your business with Pepper Cloud CRM — the Best CRM
              software United Kingdom. Streamline workflows, boost customer
              engagement, and drive growth with our all-in-one platform.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-powered automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  WhatsApp integration
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Omnichannel communication
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about the best CRM software United Kingdom
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM provider in the United Kingdom
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM for UK businesses
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={"Benefits of using a CRM for UK businesses"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Applications and use cases of UK CRM software
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Real Estate
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 Best CRM Software in the UK in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - Best CRM software in the UK"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Boost sales and drive growth with the leading CRM solution for UK
              businesses
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HongKong;
